import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73dd9178"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "average-container f1 fv w100" }
const _hoisted_2 = {
  class: "fh-s-b",
  style: {"height":"8.33%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, null, -1))
const _hoisted_4 = { class: "duration-list f1 fh-c-b w100" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "duration-total f1 fv-s-c" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "f1",
  style: {"height":"20px"}
}, null, -1))
const _hoisted_9 = { class: "f1 fh-c-b w100" }
const _hoisted_10 = { class: "fs48 color-08 bold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs24 color-08 bold" }, "%", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs14 color-06 bold" }, "好评率", -1))
const _hoisted_13 = {
  class: "f1 w100",
  style: {"height":"40px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menuItem = _resolveComponent("a-menuItem")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_progress = _resolveComponent("a-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_dropdown, { style: {"width":"200px"} }, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, { class: "menu" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTime('THIS_DAY')))
                  }, "今日")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTime('THIS_WEEK')))
                  }, "本周")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTime('THIS_MONTH')))
                  }, "本月")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTime('THIS_YEAR')))
                  }, "本年")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "fs12 color-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, _toDisplayString(_ctx.timeFilter(_ctx.timeRef)), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solveDurationData, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: index
        }, [
          _createElementVNode("div", {
            class: "fs24 color-08 bold",
            title: item.value
          }, _toDisplayString(item.value), 9, _hoisted_5),
          _createElementVNode("div", {
            class: "fs12 color-06 t-line-1",
            style: {"margin-top":"16px"},
            title: item.label
          }, _toDisplayString(item.label), 9, _hoisted_6)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.solvePercent), 1),
          _hoisted_11
        ]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_a_progress, {
          "stroke-color": { from: '#0E42D2', to: '#52C5FF' },
          "stroke-width": 12,
          percent: _ctx.solvePercent,
          trailColor: "var(--progress-color)",
          showInfo: false
        }, null, 8, ["percent"])
      ])
    ])
  ]))
}